export var DateSharedCssClassName = {
  DATE_WRAPPER: "date-lozenger-container",
  DATE_CONTAINER: 'dateView-content-wrap'
};